<template>
  <div class="purchase-records-details">
    <div class="details-content">
      <div class="info-box">
        <div class="info-title">会员信息</div>
        <div class="info-row">
          <div class="info-name">会员名称</div>
          <div class="info-value">{{userInfo.userName}}</div>
        </div>
        <div class="info-row">
          <div class="info-name">手机号</div>
          <div class="info-value">{{userInfo.phoneNo}}</div>
        </div>
      </div>
        
      <div class="info-box">
        <div class="info-title">订单信息</div>
        <div class="info-row">
          <div class="info-name">订单号</div>
          <div class="info-value">{{details.orderNo}}</div>
        </div>
        <div class="info-row">
          <div class="info-name">等级类型</div>
          <div class="info-value">{{details.vipName}}</div>
        </div>
        <div class="info-row">
          <div class="info-name">购买时长</div>
          <div class="info-value">{{getVipDays(details)}}</div>
        </div>
        <!-- <div class="info-row">
          <div class="info-name">购买类型</div>
          <div class="info-value"></div>
        </div> -->
        <div class="info-row">
          <div class="info-name">支付方式</div>
          <div class="info-value">{{details.purchaseWayDesc}}</div>
        </div>
        <div class="info-row" v-if="details.purchaseWay == 1">
          <div class="info-name">支付金额</div>
          <div class="info-value">{{details.transactionAmount}}元</div>
        </div>
        <div class="info-row" v-else-if="details.purchaseWay == 2">
          <div class="info-name">支付积分</div>
          <div class="info-value">{{details.transactionPoints}}</div>
        </div>
        <div class="info-row">
          <div class="info-name">购买时间</div>
          <div class="info-value">{{details.transactionTime}}</div>
        </div>
        <div class="info-row">
          <div class="info-name">生效时间</div>
          <div class="info-value">{{details.vipBeginTime}}</div>
        </div>
        <div class="info-row">
          <div class="info-name">到期时间</div>
          <div class="info-value">{{details.vipEndTime}}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {  } from "vant";
import {
  getUserBaseInfo
} from "../../common/api";

export default {
  name: "purchase-records-details",
  components: {
  },
  data() {
    return {
      details: {},
      userInfo: {}
    }
  },
  mounted() {
    this.details = this.$common.get('purchase-records-details') || {};
    this.getUserInfo();
  },
  methods: {
    getUserInfo() {
      getUserBaseInfo(null, true).then((response) => {
        if (
          response.status == this.$config.ajaxStatus &&
          response.data.length > 0
        ) {
          this.userInfo = response.data[0];
        }
      });
    },
    getVipDays(item){
      if(item.vipBeginTime && item.vipEndTime){
        let start = new Date(item.vipBeginTime).getTime()/ 1000;
        let end = new Date(item.vipEndTime).getTime()/ 1000;
        let x = end - start;
        let day = 60 * 60 * 24;
        let totalDay = Math.ceil( x / day);
        if(totalDay < item.vipDays){
          return totalDay + '天'
        }else{
          return item.vipDaysDesc
        }
      }else{
        return item.vipDaysDesc
      }
    }

  }
}
</script>
<style lang="less">
.purchase-records-details{
  min-height: 100%;
  background-color: #F5F4F9;
  padding: 0.2rem;
  box-sizing: border-box;
  .details-content{
    background-color: #fff;
    border-radius: 0.12rem;
    padding: 0 0.2rem;
    .info-box:first-child{
      border-bottom: 1px solid #D8D8D8;
    }
    .info-box{
      padding: 0.2rem 0;
      .info-title{
        color: #000000;
        font-size: 0.28rem;
        line-height: 0.4rem;
      }
      .info-row{
        margin-top: 0.2rem;
        display: flex;
        font-size: 0.24rem;
        line-height: 0.33rem;
        .info-name{
          width: 1.56rem;
          color: #999999;
        }
        .info-value{
          flex: 1;
          color: #000;
        }
      }
    }
  }
}
</style>